import React from 'react';
import { FiHome, FiUser, FiFileText, FiCreditCard, FiMenu } from 'react-icons/fi';
import { NavLink, useLocation } from 'react-router-dom';

import { useAuth } from '../../context/AuthContext';

/**
 * @component BottomNav
 * @description Navegación inferior fija para acceso rápido en dispositivos móviles
 * @vibe-color 🔵 #3B82F6
 * @vibe-icon 📱
 */

const BottomNav: React.FC = () => {
  const { user } = useAuth();
  const location = useLocation();
  
  // Si el usuario no está autenticado o si está en una página de auth, no mostramos la barra
  if (!user || location.pathname.includes('/auth/')) {
    return null;
  }

  // Determinar si estamos en páginas de dashboard
  const isDashboardPage = location.pathname.includes('/dashboard');
  
  // Solo mostrar en páginas de dashboard
  if (!isDashboardPage) {
    return null;
  }
  
  return (
    <nav className="md:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 pb-safe-bottom z-50">
      <div className="grid grid-cols-5 h-16">
        <NavLink 
          to="/dashboard" 
          end
          className={({ isActive }) => 
            `flex flex-col items-center justify-center py-1 ${
              isActive ? 'text-primary-600' : 'text-gray-500'
            }`
          }
        >
          <FiHome className="text-xl mb-1" />
          <span className="text-xs">Inicio</span>
        </NavLink>
        
        <NavLink 
          to="/dashboard/emergency" 
          className={({ isActive }) => 
            `flex flex-col items-center justify-center py-1 ${
              isActive ? 'text-primary-600' : 'text-gray-500'
            }`
          }
        >
          <FiUser className="text-xl mb-1" />
          <span className="text-xs">Perfil</span>
        </NavLink>
        
        <NavLink 
          to="/dashboard/documents" 
          className={({ isActive }) => 
            `flex flex-col items-center justify-center py-1 ${
              isActive ? 'text-primary-600' : 'text-gray-500'
            }`
          }
        >
          <FiFileText className="text-xl mb-1" />
          <span className="text-xs">Docs</span>
        </NavLink>
        
        <NavLink
          to="/planes"
          className={({ isActive }) =>
            `flex flex-col items-center justify-center py-1 ${
              isActive ? 'text-primary-600' : 'text-gray-500'
            }`
          }
        >
          <FiCreditCard className="text-xl mb-1" />
          <span className="text-xs">Plan</span>
        </NavLink>
        
        <NavLink 
          to="/dashboard/settings" 
          className={({ isActive }) => 
            `flex flex-col items-center justify-center py-1 ${
              isActive ? 'text-primary-600' : 'text-gray-500'
            }`
          }
        >
          <FiMenu className="text-xl mb-1" />
          <span className="text-xs">Más</span>
        </NavLink>
      </div>
    </nav>
  );
};

export default BottomNav;
